import { render, staticRenderFns } from "./Client-words-carousel.vue?vue&type=template&id=3e536d5f&scoped=true&"
import script from "./Client-words-carousel.vue?vue&type=script&lang=js&"
export * from "./Client-words-carousel.vue?vue&type=script&lang=js&"
import style0 from "./Client-words-carousel.vue?vue&type=style&index=0&id=3e536d5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e536d5f",
  null
  
)

export default component.exports